module.exports = __webpack_public_path__ + "media/images/icon-email-user-1359c84fe7e1aaa1a8f9ca05393f5d40.svg";